import React from "react";
import { Link } from "react-router-dom";

import TallCard from "../TallCard";
import ProjectsList from './ProjectsList.json';

const ProjectsGrid = () => {
    return (
        <>
            <section className="projects">
                <div className="container">
                    <p className="section-title">Projects</p>
                    <div className="grid">
                        {ProjectsList.map(({handle, title, desc, stack, image}, index) => {
                            return (
                                <Link to={`/project/${handle}`} key={index}>
                                    <TallCard title={title} desc={desc} stack={stack} image={image} />
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </section>
        </>
    );
};

export default ProjectsGrid;